import { useTranslation } from 'react-i18next';
import { Columns2, Layers } from 'lucide-react';
import { cn } from '@/lib/utils.ts';
import type { SpatialLayoutMode } from '@/lib/spatial-order.ts';

interface SpatialLayoutSwitchProps {
  layout: SpatialLayoutMode;
  onLayoutChange: (layout: SpatialLayoutMode) => void;
}

export function SpatialLayoutSwitch({ layout, onLayoutChange }: SpatialLayoutSwitchProps) {
  const { t } = useTranslation();

  return (
    <div className="spatial-layout-switch" role="group" aria-label={t('dashboard.layoutSwitch')}>
      <button
        type="button"
        className={cn('spatial-layout-switch-btn', layout === 'stack' && 'is-active')}
        aria-pressed={layout === 'stack'}
        aria-label={t('dashboard.layoutStack')}
        title={`${t('dashboard.layoutStack')} (S)`}
        onClick={() => onLayoutChange('stack')}
        onPointerDown={(event) => event.stopPropagation()}
      >
        <Layers className="size-4" strokeWidth={1.8} aria-hidden="true" />
        <span className="spatial-layout-switch-label sr-only">{t('dashboard.layoutStack')}</span>
      </button>
      <button
        type="button"
        className={cn('spatial-layout-switch-btn', layout === 'tile' && 'is-active')}
        aria-pressed={layout === 'tile'}
        aria-label={t('dashboard.layoutTile')}
        title={`${t('dashboard.layoutTile')} (T)`}
        onClick={() => onLayoutChange('tile')}
        onPointerDown={(event) => event.stopPropagation()}
      >
        <Columns2 className="size-4" strokeWidth={1.8} aria-hidden="true" />
        <span className="spatial-layout-switch-label sr-only">{t('dashboard.layoutTile')}</span>
      </button>
    </div>
  );
}
